import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDr8THBGijAbQzT14O7qeBE3xvqNF-VHHE",
  authDomain: "digitalmenu-e82c4.firebaseapp.com",
  databaseURL: "https://digitalmenu-e82c4-default-rtdb.firebaseio.com",
  projectId: "digitalmenu-e82c4",
  storageBucket: "digitalmenu-e82c4.appspot.com",
  messagingSenderId: "1004438381485",
  appId: "1:1004438381485:web:20386e610803eec70ab724",
  measurementId: "G-T5WNLRZNW5",
};

const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);

const database = getDatabase(firebaseApp);

const storage = getStorage(firebaseApp);

export async function uploadFile(file, name) {
  const storageRef = ref(storage, `/upload_images/${name}`) 


  await uploadBytes(storageRef, file)
  let data = await getDownloadURL(storageRef)

  return data
}

export { db, database, firebaseConfig };
